module.exports = __webpack_public_path__ + "img/product3.ed22e6a8.png";